(function () {
	var params = new URLSearchParams(window.location.search);
	if (params.get('cart_origin') !== 'meta_shops') return;

	var productsParam = params.get('products');
	if (!productsParam) return;

	var lookupUrl = document.currentScript && document.currentScript.getAttribute('data-lookup-url');
	if (!lookupUrl) return;

	var requested = productsParam.split(',').map(function (pair) {
		var parts = pair.split(':');
		return { id: decodeURIComponent(parts[0]), quantity: parseInt(parts[1], 10) || 1 };
	}).filter(function (entry) {
		return entry.id;
	});

	if (!requested.length) return;

	fetch(lookupUrl)
		.then(function (res) { return res.json(); })
		.then(function (idToHandle) {
			var lines = requested.map(function (entry) {
				var handle = idToHandle[entry.id] || entry.id;
				return fetch('/products/' + handle + '.js')
					.then(function (res) { return res.ok ? res.json() : null; })
					.then(function (product) {
						if (!product) return null;
						var variant = product.variants.find(function (v) { return v.sku === entry.id; }) || product.variants[0];
						return variant ? { id: variant.id, quantity: entry.quantity } : null;
					})
					.catch(function () { return null; });
			});

			return Promise.all(lines);
		})
		.then(function (lines) {
			var items = lines.filter(Boolean);
			if (!items.length) return;

			return fetch('/cart/clear.js', { method: 'POST' })
				.then(function () {
					return fetch('/cart/add.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({ items: items }),
					});
				})
				.then(function () {
					window.location.href = '/cart';
				});
		})
		.catch(function (err) {
			console.error('Meta checkout cart prefill failed:', err);
		});
})();
